<template>
  <div class="chat-box">
    <div class="chat-box-board" v-show="showChatBoard == true">
      <div>
        <div class="chat-box-board-header" @click="$emit('chat-header-click')">
          <!-- <i v-if="connected == true" class="icon ion-ios-radio is-connected"></i>
          <i v-if="connected == false" class="icon ion-ios-radio is-disconnected"></i>
          <span>{{ onlineStatus }}</span>-->
          <span>{{participant.name}}</span>
        </div>
        <div class="chat-box-board-msgs" ref="chatList">
          <div
            class="chat-box-board-msgs-line"
            v-for="(entity, index) in queue"
            :key="'msg-' + index"
          >
            <p :class="{'is-for-owner': entity.author =='me'}">
              <!-- <a
                class="chat-box-board-attachment"
                :href="entity.attachments[0].url"
                v-if="entity.attachments.length > 0"
                target="_blank"
              >{{ entity.attachments[0].filename }}.{{ entity.attachments[0].extension }}</a>-->
              <!-- <span
                v-if="decodeURIComponent(entity.message) != 'null'"
              >{{ decodeURIComponent(entity.message) }}</span>-->

              <span>{{entity.text}}</span>
            </p>
            <div class="message-date-box" :class="{'has-text-right':entity.author =='me'}">
              <span>{{$moment(entity.data.meta.date).tz(entity.data.meta.timezone).format("Y-M-D [at] H:mm:ss")}}</span>
            </div>

            <div class="divider"></div>
          </div>
        </div>
        <div :class="{'is-loading':sendingMessage}" class="chat-box-board-input">
          <div v-if="showEmojiBoard == true">
            <emoji-picker class="emojiPicker">
              <i
                slot="emoji-invoker"
                slot-scope="{events: {click: clickEvent}}"
                @click.stop="clickEvent"
                ref="chatEmojiOpen"
                class="icon ion-ios-happy hidden"
              ></i>
              <div slot="emoji-picker" slot-scope="{emojis}">
                <div class>
                  <div class>
                    <input class="input" placeholder="Search..." type="text" v-model="search" />
                  </div>
                  <div class="emojiBox">
                    <div v-for="(emojiGroup, category) in emojis" :key="category">
                      <h5 class>{{ category }}</h5>
                      <div class>
                        <button
                          class="button"
                          v-for="(emoji, emojiName) in emojiGroup"
                          :key="emojiName"
                          :title="emojiName"
                          @click="appendEmoji(emoji)"
                        >{{ emoji }}</button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </emoji-picker>
            <uploader v-if="allowFiles" :oneachfile="onEachFile">
              <template slot="button">
                <i class="icon ion-ios-add"></i>
              </template>
            </uploader>
          </div>
          <div class="columns">
            <div class="column" v-on-clickaway="detachFileInput">
              <form @submit.prevent="sendMessage">
                <input type="text" placeholder="Write a message" v-model="message" />
              </form>
            </div>
            <div v-if="allowEmojis" class="column is-narrow">
              <button @click.stop="openChatEmoji" class="button emojiButton">😃</button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <button
      :class="['chat-box-toggle-state', {'active': showChatBoard == true},{'is-new-message': hasNewMessage == true}]"
      @click="displayChatBoard"
    >
      <i v-if="showChatIcon" class="icon ion-ios-chatbubbles"></i>
      <i v-else class="icon ion-ios-close"></i>
    </button>
  </div>
</template>

<script>
import { mixin as clickaway } from "vue-clickaway";
// import VueUpload from "./Vue-Upload";

export default {
  mixins: [clickaway],
  name: "Chat",
  components: {
    // uploader: VueUpload,
  },

  data() {
    return {
      showUploadBox: false,
      message: null,
      sendingMessage: false,
      messageType: "text",
      messageAttachment: null,
      showEmojiBoard: true,
      search: null,
    };
  },

  props: {
    connected: {
      type: Boolean,
      default: false,
    },
    showChatBoard: {
      type: Boolean,
      default: false,
    },
    showChatIcon: {
      type: Boolean,
      default: false,
    },
    allowEmojis: {
      type: Boolean,
      default: false,
    },
    allowFiles: {
      type: Boolean,
      default: false,
    },

    timestamp: {
      type: String,
      default: "created_at",
    },

    senderIdLabel: {
      type: String,
      default: "id",
    },

    senderIdValue: {
      type: Number,
      default: 0,
    },
    queue: {
      type: Array,
      default() {
        return [];
      },
    },

    participant: {
      type: Object,
      default() {
        return {};
      },
    },
    hasNewMessage: {
      type: Boolean,
      default: false,
    },

    onMessageSend: {
      type: Function,
      default() {
        return null;
      },
    },

    onBoardStateChange: {
      type: Function,
      default() {
        return null;
      },
    },

    onRecipientSelected: {
      type: Function,
      default: () => {
        return null;
      },
    },

    onlineStatus: {
      type: String,
      default: "Online",
    },

    file: {
      type: String,
      default: null,
    },

    attachmentDetachedEvent: {
      type: String,
      default: "onAttachmentDetached",
    },

    uploadInputResetEvent: {
      type: String,
      default: "VueUploadComponentInputReset",
    },
  },
  watch: {
    showChatBoard(newValue) {
      if (newValue == true) {
        this.$nextTick(() => {
          this.scrollToBottom();
        });
      }
    },
    hasNewMessage(newValue) {
      if (this.hasNewMessage == true && this.showChatBoard == true) {
        this.$nextTick(() => {
          this.scrollToBottom();
        });
      }
    },
  },
  methods: {
    detachFileInput() {
      this.messageAttachment = null;
      this.$root.$emit(this.uploadInputResetEvent);
    },
    openChatEmoji() {
      this.$refs.chatEmojiOpen.click();
    },

    scrollToBottom() {
      var list = this.$refs["chatList"];
      list.scrollTop = list.scrollHeight;
      this.$emit("chat-scrolled", true);
    },

    appendEmoji(emoji) {
      if (this.message == null) {
        this.message = "";
      }
      this.message += emoji;
    },

    displayChatBoard() {
      this.$emit("chat-bubble-click");
      this.$nextTick(() => {
        this.message = null;
      });
    },

    sendMessage() {
      if (typeof this.onMessageSend == "function") {
        this.sendingMessage = true;
        this.onMessageSend(this.message, this.messageAttachment).then(() => {
          this.scrollToBottom();
          this.message = null;
          this.sendingMessage = false;
        });
      }
    },

    onEachFile(file) {
      let initialMessageValue = this.message;

      this.$swal
        .fire({
          imageUrl:
            "https://cdn1.iconfinder.com/data/icons/hawcons/32/699055-icon-65-document-image-256.png",
          imageHeight: 150,
          text: file.filename + "." + file.extension,
          confirmButtonText: "Send",
          showCloseButton: true,
          cancelButtonText: "Cancel",
          allowEscapeKey: false,
          allowOutsideClick: false,
          input: "text",
          inputPlaceholder: "Add a message about the file",
          inputValue: this.message,
        })
        .then((result) => {
          if (result.dismiss != undefined) {
            switch (result.dismiss) {
              case "close":
                this.detachFileInput();
                break;
            }
          } else {
            this.message = result.value;
            this.messageAttachment = file;
            this.sendMessage();
          }
        });
    },
  },

  mounted() {
    this.$root.$on(this.attachmentDetachedEvent, () => {
      this.messageAttachment = null;
    });
  },
};
</script>
